import { Card, Col, Form, Icons, Input, Row, Switch } from "@pankod/refine-antd";
import { IPartner } from "interfaces/partner";
import { FC } from "react";
import { MyFormProps } from ".";
import { normalizePartnerPhone } from "utils/formaters";

type PartnerFormProps = MyFormProps & {
  transformValuesOnSubmit?: (values: IPartner) => IPartner;
};

export const PartnerForm: FC<PartnerFormProps> = ({
  formProps,
  transformValuesOnSubmit,
}) => {
  const handleFinish = (values: IPartner) => {
    const transformedValues = transformValuesOnSubmit
      ? transformValuesOnSubmit(values)
      : values;

    formProps.onFinish?.(transformedValues);
  };

  return (
    <Card>
      <Form
        {...formProps}
        onFinish={handleFinish}
        layout="vertical"
        style={{ padding: 16 }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <Form.Item
              label="Nome"
              name="partner_name"
              rules={[
                {
                  required: true,
                  message: "Nome é obrigatório",
                  min: 1,
                },
              ]}
            >
              <Input placeholder="Nome" />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Código do Parceiro"
              tooltip={{
                title:
                  "É obrigatório o preenchimento deste campo somente com caracteres em minúsculo. Ao detectar um caractere maiúsculo, o valor é propositalmente convertido para minúsculo de forma automática.",
                icon: <Icons.InfoCircleOutlined />,
              }}
              name="partner_code"
              normalize={(value) => (value ? value.toLowerCase() : "")}
              rules={[
                {
                  required: true,
                  message: "Código do Parceiro é obrigatório",
                  min: 2,
                },
              ]}
            >
              <Input placeholder="Código do Parceiro" />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Telefone"
              name="partner_phone"
              rules={[
                {
                  required: true,
                  message: "Telefone é obrigatório",
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    const normalizedPhone = normalizePartnerPhone(value);
                    const nationalDigits = normalizedPhone.startsWith("55")
                      ? normalizedPhone.slice(2)
                      : normalizedPhone;

                    if (
                      (nationalDigits.startsWith("0800") &&
                        nationalDigits.length === 11) ||
                      nationalDigits.length === 10 ||
                      nationalDigits.length === 11
                    ) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error("Número de telefone inválido")
                    );
                  },
                },
              ]}
            >
              <Input placeholder="Telefone" maxLength={20} />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="URL"
              name="partner_url"
            >
              <Input placeholder="URL" />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="API Key"
              name="partner_api_key"
            >
              <Input placeholder="API Key" />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Parceiro Padrão"
              name="partner_default"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
